<template>
  <div>          
    <v-slider color="transparent"  thumb-color="primary" class="mx-2 my-0" hide-details ref="slider"  thumb-label thumb-size="32" :value="currentValue" @input="changeValue" :min="0" :max="allYos.length > 0?allYos.length-1:0" step=1 >
      <template slot="thumb-label" slot-scope="props">
        <span class="text-[10px] text-center leading-tight">
          <span class="text-[8px]">{{  `G${allYos?.[currentValue]?.gliderNum}` }}</span><br/>{{allYos?.[currentValue]?.cycle}}
        </span>
      </template>        
    </v-slider>        
    <v-layout v-show="true" caption mx-1 pa-0 justify-center>      
      <v-btn class="mx-0" @click="isPlaying = !isPlaying" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.PlayMissionTooltip')"><v-icon v-html="isPlaying?'mdi-pause':'mdi-play'" ></v-icon></v-btn>
      <v-btn class="mx-0" @click="isPlaying = true" v-if="!isPlaying && currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.ReplayMissionTooltip')"><v-icon>mdi-replay</v-icon></v-btn>
      <v-spacer />
      <span>
        <v-btn class="mx-0" @click="changeValue(0)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToFirstYoTooltip')"><v-icon >mdi-skip-previous</v-icon></v-btn>
        <v-btn class="mx-0" @click="goPrevYo(currentValue)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToPreviousSurfacingYoTooltip')"><v-icon >mdi-chevron-double-left</v-icon></v-btn>        
        <v-btn class="mx-0" @click="changeValue(currentValue-1)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToPreviousYoTooltip')"><v-icon >mdi-chevron-left</v-icon></v-btn>        
        <span style="display:inline-block;width:97px;text-align:center" v-if="allYos?.[currentValue]?.isUnderWater">{{ `G${allYos?.[currentValue]?.gliderNum}` }}: {{$t('Pilot.MissionDrawer.Cycle')}} {{allYos?.[currentValue]?.cycle}}</span><template v-else>{{currentDate | formatDate}}</template>
        <v-btn class="mx-0" @click="changeValue(currentValue+1)" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToNextYoTooltip')"><v-icon >mdi-chevron-right</v-icon></v-btn>
        <v-btn class="mx-0" @click="goNextYo(currentValue)" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToNextSurfacingYoTooltip')"><v-icon >mdi-chevron-double-right</v-icon></v-btn>
        <v-btn class="mx-0" @click="changeValue(allYos.length-1)" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToLastYoTooltip')"><v-icon >mdi-skip-next</v-icon></v-btn>
      </span>            
    </v-layout>    
  </div> 
</template>
<script setup lang="ts">
  
  import { ref,computed, watch } from 'vue'
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'  
  import store from '@/store'    
  import { buildCoverageIterationMissionUiStateId } from '@/models/ui/CoverageIterationMissionUiState'  
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'
  import { AloMission } from '@/models/alo/AloMission'
  import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
import mission from '@/api/mission'

  const isPlaying = ref(false)

  const _currentValue = ref(-1)
  
  const currentValue = computed({
    get: () => _currentValue.value == -1?(allYos.value.length > 0?allYos.value.length-1:0): _currentValue.value,
    set: (val) => {
      _currentValue.value = val
    }
  })  
  
  const props = defineProps<{    
    fleet:AloDbFleet,
    uiid:string}>()
    
  const fleetState = computed(()=> store.myGetters.fleetUiStateByUiid(props.uiid))
  
  const  missions = computed(()=> props.fleet.param?.missionIds?.map(id => store.myGetters?.missionsById[id])?.filter(m => !!m) ?? [])
  

  const timelineIndex = computed(()=> fleetState.value.timelineIndex)

  const missionTimelineIndex = computed(()=> missions.value.map(mission => store.myGetters.missionUiStateByUiid(buildMissionUIStateId(mission.misId!,'fleet')).timelineIndex))

  const currentDate = computed(()=> allYos.value?.[currentValue.value]?.date)

  const canUpdateYoIndex = ref(true)

  function changeValue(newValue:number){
    fleetState.value.timelineIndex = newValue
  }
  

  const allYos = computed(()=> 
    missions.value.reduce((acc, mission, misIdx) => {
      const yos = mission.yoArray?.map((y,idx) => ({misId:mission.misId!,gliderNum:misIdx+1,idx,date:y?.yoGpsDatTime,isUnderWater:y?.isUnderWater,cycle:y?.yosCycle})) ?? [] 
      let lastDate = yos?.at(0)?.date!
      yos?.forEach(y => {        
        if(y.date.toString() =='Invalid Date') {           
          y.date = new Date(lastDate.getTime() + 1)
          lastDate = y.date
        }
        else lastDate = y.date
      })
      //@ts-ignore
      return acc.concat(yos)
    },[] as Array<{misId:number,gliderNum:number,idx:number,date:Date,isUnderWater:boolean,cycle:number}>).sort((a,b) => a.date.getTime() - b.date.getTime())
  )  
  

  function goPrevYo(val:number){
      let yo = null                
      let offset = 1
      while(val-offset >= 0 && (yo = allYos.value[val-offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater)  changeValue(val - offset)
  }

  function goNextYo(val:number){
      let yo = null              
      let offset = 1
      while(allYos.value.length > (val+offset) &&  (yo = allYos.value[val+offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater) changeValue(val + offset)
  }

  

  watch(timelineIndex, (newIndex:number) => {
    checkIndex(newIndex)
  })

  watch(missionTimelineIndex, (newIndexes:Array<number>,oldIndexes:Array<number>) => {
    if(canUpdateYoIndex.value){      
      //recherche le premier index qui a changé
      let newIndex = newIndexes.findIndex((newIndex,idx) => newIndex != oldIndexes[idx])
      const missionToFind = missions.value[newIndex]
      const indexToFind = newIndexes[newIndex]

      const newYos = allYos.value.findIndex(yo => yo?.misId == missionToFind?.misId && yo?.idx == indexToFind)
      changeValue(newYos)
    }
  })

  watch(isPlaying, (playing:boolean) => {
    if(playing) {  
      //si on reviens au debut on attend que l'animation du curseur de la time line soit fini avant de lancer le play                      
      if(currentValue.value == allYos.value.length - 1) {
        changeValue(0)
        setTimeout(() => play(),350)          
      } 
      else  {                     
        play()
      }
    }      
  })

  function play() {
      if(isPlaying.value) {
        if(currentValue.value == allYos.value.length - 1) {
          isPlaying.value = false
        }
        else{
          changeValue(currentValue.value+1)            
          setTimeout(() => play(),350)
        }     
      }
  }


  
  function checkIndex(newIndex:number) {    
    canUpdateYoIndex.value = false
    currentValue.value = newIndex != -1? newIndex : allYos.value.length-1
    //Met à jour la position de chaque glider de la simulation à l'index le plus proche
    missions.value.forEach(mission => {
      //recherche de l'index le plus proche pour chaque glider   
      let searchIndex = currentValue.value
      let searchYo = null
      while(searchIndex >= 0 &&  (searchYo = allYos.value[searchIndex]).misId != mission.misId) {
        searchIndex--;
      }         
      const missionUiStateId = buildMissionUIStateId(mission.misId!,'fleet')      
      store.myGetters.missionUiStateByUiid(missionUiStateId).timelineIndex = searchYo?.misId == mission.misId?searchYo!.idx:0
      
    })
    setTimeout(() => canUpdateYoIndex.value = true,100)
  }
  

</script> 